import * as shops from '../classes/shops';

const _shops = [
    new shops.LemonadeStand(),
    new shops.PaperDelivery(),
    new shops.ShoeShop(),
    new shops.PizzaDelivery(),
    new shops.Bakery(),
    new shops.LampStore(),
    new shops.SoccerTeam(),
    new shops.MovieStudio(),
    new shops.Airline(),
    new shops.Bank(),
    new shops.CarManufacturer(),
    new shops.DrugRing()
];

_shops.forEach(shop => {
    shop.costsBigNumber = shop.getCosts(shop.amount, 1, true);
    shop.costs = shop.costsBigNumber.toNumber();
    shop.productionTimeRemaining = Math.floor(shop.coolDown * 1000) / 1000;
});

export default {
    getShops(cb) {
        return cb(_shops);
    }
};
